import { Button } from "@root/shared/components/Button";
import { type FC } from "react";
import * as styles from "./styles.css";

type Props = {
  shopName: string;
  shopAddress?: string;
  onClick: () => void;
};

export const SearchResultContents: FC<Props> = ({ shopName, shopAddress, onClick }) => {
  return (
    <div className={styles.wrapper}>
      <div>
        <p className={styles.shopName}>{shopName}</p>
        {shopAddress && <p className={styles.shopAddress}>{shopAddress}</p>}
      </div>
      <div className={styles.buttonWrapper}>
        <Button theme="primary" onClick={onClick} className={styles.button} size="small">
          選択
        </Button>
      </div>
    </div>
  );
};
